import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 8 12", style: {
  enableBackground: "new 0 0 8 12"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("style", { type: "text/css" }, "\n	.st-rightarrow{fill-rule:evenodd;clip-rule:evenodd;fill:#006DC9;}\n"), /* @__PURE__ */ React.createElement("path", { id: "Fill-1", className: "st-rightarrow", d: "M1,11.6c0.3,0.3,0.7,0.3,1,0l4.8-4.8c0.3-0.3,0.3-0.7,0-1l0,0L2,0.9c-0.3-0.3-0.7-0.3-1,0 C0.7,1.2,0.7,1.7,1,2l4.3,4.3L1,10.6C0.7,10.9,0.7,11.3,1,11.6L1,11.6z" }));
const ForwardRef = forwardRef(SvgRightArrow);
export { ForwardRef as ReactComponent };
